export interface IMailboxDescription {
	useNTLM: boolean;
	sendingOnly: boolean;
	folders: Array<IMailboxFolder>;
	mailBoxId: number;
	mailServerId: number;
	mailServer: IMailboxServerDescription;
	mailBoxName: string;
	senderName: string;
	senderEmail: string;
	leaveCopies: boolean;
	deleteOnClearTrash: boolean;
	disabled: boolean;
	lastSyncSuccessStart: string;
	lastSyncSuccessEnd: string;
	lastSyncAttemptStart: string;
	lastSyncAttemptEnd: string;
	lastSyncSuccess: boolean;
	lastSyncException: string;
	invalidCredentials: boolean;
	emailStoreDuration: number;
	doNotGenerateAddressBook: boolean;
	daysCountToSyncOldMail: number;
	mailboxConnectFailsAttempts: number;
}

export enum MailboxFolderType {
	inbox = 'Inbox',
	sent = 'Sent',
	outbox = 'Outbox',
	drafts = 'Drafts',
	folder = 'Folder',
	trash = 'Trash',
}

export interface IMailboxFolder {
	parentFolderId?: number;
	folderId: number;
	mailBoxId: number;
	mailBox?: any;
	mailServer?: any;
	folderName: string;
	serverId: number;
	serverName: string;
	serverPath?: string;
	disabled: boolean;
	isLocal: boolean;
	folderType: MailboxFolderType;
	maxMessageId: number;
	nextMessageId: number;
	messageCount: number;
	unreadCount: number;
	lastSyncSuccessStart?: string;
	lastSyncSuccessEnd?: string;
	lastSyncAttemptStart?: string;
	lastSyncAttemptEnd?: string;
	lastSyncSuccess?: string | boolean;
	lastSyncException?: string;
	isFolderExpandable?: boolean;
	isFolderExpand?: boolean;
	isHidden?: boolean;
}

export interface IMailboxServerDescription {
	mailServerId: number;
	name: string;
	imapAddress: string;
	smtpAddress: string;
	imapUseSSL: boolean;
	smtpUseSSL: boolean;
	imapPort: number;
	smtpPort: number;
	smtpAnonymous: boolean;
	isExchange: boolean;
	isGmail: boolean;
	mailServerCategoryId: number;
	mailServerCategoryName: string;
	isMailServerGmail: boolean;
	emailDomains: string;
	emailDomainsList: string[];
	noRetryErrors: string;
	noRetryErrorsList: string[];
	receivedHeader: string;
	sslProtocol: string;
}
